// Visual email builder model and renderers.
//
// A "design" is a small structured object the non technical editor manipulates
// through friendly fields. It is rendered to the HTML/text that actually get
// sent. Variable placeholders ({{...}}) typed by the user (via the friendly
// chips) are preserved verbatim so the server template engine can substitute
// them; everything else the user types is HTML escaped so plain text stays
// safe and cannot break the layout.

export const VARIABLES = [
  { token: '{{event.label}}', label: 'Nome evento' },
  { token: '{{summary}}', label: 'Riepilogo' },
  { token: '{{event.category}}', label: 'Categoria' },
  { token: '{{event.severity}}', label: 'Gravità' },
  { token: '{{actor.email}}', label: 'Chi ha agito' },
  { token: '{{subject.email}}', label: 'Persona interessata' },
  { token: '{{target.label}}', label: 'Risorsa coinvolta' },
  { token: '{{date}}', label: 'Data e ora' },
  { token: '{{app.name}}', label: 'Nome applicazione' },
  { token: '{{app.baseUrl}}', label: 'Indirizzo pannello' }
];

export const DETAIL_FIELDS = [
  { key: 'category', label: 'Categoria', token: '{{event.category}}' },
  { key: 'severity', label: 'Gravità', token: '{{event.severity}}' },
  { key: 'actor', label: 'Chi ha agito', token: '{{actor.email}}' },
  { key: 'subject', label: 'Persona interessata', token: '{{subject.email}}' },
  { key: 'target', label: 'Risorsa', token: '{{target.label}}' },
  { key: 'date', label: 'Data e ora', token: '{{date}}' }
];

export const DEFAULT_DESIGN = {
  showLogo: true,
  heading: '{{event.label}}',
  intro: '{{summary}}',
  showDetails: true,
  detailFields: ['category', 'severity', 'actor', 'subject', 'target'],
  button: { label: 'Apri il pannello', url: '{{app.baseUrl}}/admin/logs' },
  footer: '{{app.name}} - notifica automatica'
};

export const DEFAULT_SUBJECT = '[{{app.name}}] {{event.label}}';

function escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// Escape literal user text while leaving {{tokens}} (and {{{raw}}}) untouched.
function escapePreservingTokens(s) {
  return String(s == null ? '' : s)
    .split(/(\{\{\{?[^}]+\}?\}\})/)
    .map((part) => (/^\{\{/.test(part) ? part : escapeHtml(part)))
    .join('');
}

export function renderDesignToHtml(d = {}) {
  const heading = escapePreservingTokens(d.heading || '');
  const intro = escapePreservingTokens(d.intro || '').replace(/\n/g, '<br>');

  const rows = (d.showDetails ? (d.detailFields || []) : [])
    .map((k) => DETAIL_FIELDS.find((f) => f.key === k))
    .filter(Boolean)
    .map((f) => `    <tr><td style="padding:6px 0;color:#9b9b98">${escapeHtml(f.label)}</td><td style="padding:6px 0">${f.token}</td></tr>`)
    .join('\n');
  const table = rows
    ? `  <table style="width:100%;border-collapse:collapse;font-size:13px">\n${rows}\n  </table>`
    : '';

  const button = (d.button && d.button.label)
    ? `  <p style="margin-top:20px"><a href="${escapePreservingTokens(d.button.url || '')}" style="display:inline-block;background:#0d0d0d;color:#ffffff;text-decoration:none;padding:9px 16px;border-radius:6px;font-size:13px">${escapePreservingTokens(d.button.label)}</a></p>`
    : '';

  const footer = d.footer
    ? `  <p style="color:#9b9b98;font-size:11px;margin-top:24px">${escapePreservingTokens(d.footer)}</p>`
    : '';

  const logo = d.showLogo !== false
    ? '  <div style="margin:0 0 16px"><img src="{{app.logoUrl}}" alt="{{app.name}}" style="height:32px;width:auto;display:block;border:0" /></div>'
    : '';

  return [
    '<div style="font-family:Inter,Arial,sans-serif;max-width:560px;margin:0 auto;color:#0d0d0d">',
    logo,
    heading ? `  <h2 style="font-size:18px;margin:0 0 4px">${heading}</h2>` : '',
    intro ? `  <p style="color:#5d5d5b;font-size:13px;margin:0 0 16px">${intro}</p>` : '',
    table,
    button,
    footer,
    '</div>'
  ].filter(Boolean).join('\n');
}

export function renderDesignToText(d = {}) {
  const lines = [];
  if (d.heading) lines.push(d.heading);
  if (d.intro) lines.push(d.intro);
  if (d.showDetails) {
    (d.detailFields || []).forEach((k) => {
      const f = DETAIL_FIELDS.find((x) => x.key === k);
      if (f) lines.push(`${f.label}: ${f.token}`);
    });
  }
  if (d.button && d.button.url) lines.push(d.button.url);
  if (d.footer) lines.push(d.footer);
  return lines.join('\n');
}
